import { Router } from '@angular/router';

/**
 * Whether the running navigation came straight from `path` through a link, so
 * `location.back()` returns to that page (at its scroll position) instead of
 * stacking a second copy of it in the history. Call it while the routed
 * component is constructed, when that navigation is still current.
 */
export function cameFrom(router: Router, path: string): boolean {
  const nav = router.currentNavigation();
  const previous = nav?.previousNavigation?.finalUrl;
  if (!nav || nav.trigger === 'popstate' || !previous) {
    return false;
  }
  return router.serializeUrl(previous).split(/[?#]/)[0] === path;
}
